"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemPublicProvider = void 0;
var QuoteLineItemContext_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteLineItem/QuoteLineItemContext");
var react_1 = __importDefault(require("react"));
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var useMobxEject_1 = require("@CommonFrontend/hooks/useMobxEject");
var QuoteLineItemCurrencyField_1 = require("./QuoteLineItemCurrencyField");
var QuoteLineItemNumberField_1 = require("./QuoteLineItemNumberField");
var QuoteLineItemPublicProvider = function (_a) {
    var initialItem = _a.item, id = _a.id, initialPrice = _a.price, di = _a.di, children = _a.children;
    var _b = (0, useMobxEject_1.useMobxEject)(function () {
        var quoteSummaryStore = di === null || di === void 0 ? void 0 : di.get("quoteSummaryStore");
        if (!quoteSummaryStore)
            return { item: initialItem, price: initialPrice };
        return {
            item: __assign(__assign({}, initialItem), (0, Helpers_1.getQuoteSummaryForItem)(quoteSummaryStore.quoteSummary, "lineItem", id)),
            price: (0, Helpers_1.getPriceSummaryForItem)(quoteSummaryStore.priceSummary, id),
        };
    }), item = _b.item, price = _b.price;
    return (react_1.default.createElement(QuoteLineItemContext_1.QuoteLineItemProvider, { value: {
            components: {
                CurrencyField: QuoteLineItemCurrencyField_1.QuoteLineItemCurrencyField,
                NumberField: QuoteLineItemNumberField_1.QuoteLineItemNumberField,
            },
            item: item,
            id: id,
            price: price,
            actions: {
                toggleItemSelected: function () {
                    var _a;
                    (_a = di === null || di === void 0 ? void 0 : di.get("quoteSummaryStore")) === null || _a === void 0 ? void 0 : _a.toggleLineItemSelected(id);
                },
            },
        } }, children));
};
exports.QuoteLineItemPublicProvider = QuoteLineItemPublicProvider;
